// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fA","advertDetailContactGroup__header":"c-m_fB","advertDetailContactGroup__value":"c-m_fC"};